import { type HeadCell } from 'components/ui/EnhancedTable';
import useAxios from 'library/axios';
import { useState } from 'react';
import { type ISequenceDefinition, type ISequenceDefinitionSearch} from "../models/SequenceDefinition";
import { useTranslation } from 'react-i18next';
import { type ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { useNavigate } from 'react-router-dom';


const _ = () => {

  const axios = useAxios();

  const createSequenceDefinition = async (sequenceDefinition: ISequenceDefinition) =>
    await (await axios.post('/api/setup/sequenceDefinition/create', sequenceDefinition)).data;

  const updateSequenceDefinition = async (sequenceDefinition: ISequenceDefinition) =>
    await (await axios.post('/api/setup/sequenceDefinition/update', sequenceDefinition)).data;

  const getSequenceDefinition = async (id: number) => {
    const { data } = (await axios.get(`/api/setup/sequenceDefinition/get-sequenceDefinition/${id}`));
    return await data;
  }

  const getSequenceDefinitions = async (criteria: ISequenceDefinitionSearch): Promise<ISequenceDefinition[]> => {
    const { name, code, entityName } = criteria;

    const { data } = (await axios.get(`/api/setup/sequenceDefinition/get-sequenceDefinitions?name=${name}&code=${code}&entityName=${entityName}`));
    return await data;
  }

  const getAllSequenceDefinitions = async (): Promise<ISequenceDefinition[]> => {

    const { data } = (await axios.get(`/api/setup/sequenceDefinition/get-all-sequenceDefinitions`));
    return await data;
  }

  

  return {
    createSequenceDefinition,
    updateSequenceDefinition,

    getSequenceDefinition,
    getSequenceDefinitions,

    getAllSequenceDefinitions,

  }
}

export default _;


export const useBasicFilterSequenceDefinition = (onRowDoubleClick: (event: React.MouseEvent<unknown>, row: ISequenceDefinition) => void) => {

  const { getSequenceDefinitions } = _();

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();



  const [headSequenceDefinitionCells, setHeadSequenceDefinitionCells] = useState<HeadCell<ISequenceDefinition>[]>([
    { id: 'code', label: t('Code'), display: true, type: 'string', },
    { id: 'name', label: t('Name'), display: true, type: 'string', },

    { id: 'entityName', label: t('Entity'), display: true, type: 'string', },
    { id: 'resetType', label: t('Reset'), display: true, type: 'string', },
    { id: 'startValue', label: t('Start value'), display: true, type: 'numeric', },
    { id: 'incrementBy', label: t('Increment'), display: true, type: 'numeric', },

  ]);

  const [filterElements,] = useState([
    { name: 'code', text: t('Name'), value: '' },
    { name: 'name', text: t('Name'), value: '' },
    { name: 'entityName', text: t('Entity'), value: '' },
  ]);

  const [filteredSequenceDefinitions,] = useState<ISequenceDefinition[]>([]);

  const onFilterButtonClick = async (filterElements: ITextFilterElement[]): Promise<ISequenceDefinition[]> => {

    const name = filterElements.find(elt => elt.name === 'name')?.value || '';
    const code = filterElements.find(elt => elt.name === 'code')?.value || '';
    const entityName = filterElements.find(elt => elt.name === 'entityName')?.value || '';

    const arr = await getSequenceDefinitions({ code, name, entityName });

    return arr;
  }

  const objKey: keyof ISequenceDefinition = 'id';

  return {
    title: t('Sequence definition'), headCells: headSequenceDefinitionCells, objKey,
    filterElements, rows: filteredSequenceDefinitions,
    onFilterButtonClick, onRowDoubleClick
  }
}

